/**
 * `?panel=thumbnails` deep link — how the rainvic Projects page opens a board
 * straight onto its thumbnails. Honoured once and stripped (replace, not
 * push), for the same reasons the `?thread=` link is (comments/useThreadDeepLink).
 */
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import type { ThumbUiStore } from "./store.js";

export const PANEL_PARAM = "panel";
export const THUMBNAILS_PANEL = "thumbnails";

export function useThumbnailDeepLink(ui: ThumbUiStore): void {
  const [params, setParams] = useSearchParams();
  const panel = params.get(PANEL_PARAM);

  useEffect(() => {
    if (panel !== THUMBNAILS_PANEL) return;
    ui.getState().setPanelOpen(true);
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(PANEL_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [panel, ui, setParams]);
}
